import React from 'react';
import StatusMonoHtmlView from './StatusHtml';
import StatusMonoReactView from './Status';
const StatusMonoView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(StatusMonoHtmlView, props);
    }
    return /*#__PURE__*/ React.createElement(StatusMonoReactView, props);
};
StatusMonoView.displayName = 'StatusMonoView';
export default StatusMonoView;
